import { Box } from '@mui/material'
import { getDeleteTreatmentSchemaMessage } from 'components/cattles/treatmentPage/utils/treatmentSchemaDisplay'
import { OutlinedButton } from 'ui/buttons/OutlinedButton'
import ExitWarningModal from 'ui/modal/ExitWarningModal'

interface IDeleteTreatmentSchemaModalProps {
	open: boolean
	onClose: () => void
	onConfirm: () => void
	schemaName?: string
	diagnosisNames?: string[]
}

const DeleteTreatmentSchemaModal = ({
	open,
	onClose,
	onConfirm,
	schemaName = '',
	diagnosisNames = [],
}: IDeleteTreatmentSchemaModalProps) => {
	return (
		<ExitWarningModal
			open={open}
			onClose={onClose}
			title='Удалить схему лечения'
			description={
				<Box component='span' sx={{ whiteSpace: 'pre-line' }}>
					{getDeleteTreatmentSchemaMessage(schemaName, diagnosisNames)}
				</Box>
			}
			onSaveText={'Отмена'}
			onDismissText={'Удалить'}
			saveButton={
				<OutlinedButton sx={{ height: '54px' }} onClick={onClose}>
					Отмена
				</OutlinedButton>
			}
			dismissButton={
				<OutlinedButton disableRipple onClick={onConfirm} intent='error'>
					Удалить
				</OutlinedButton>
			}
		/>
	)
}

export default DeleteTreatmentSchemaModal
